import { API, axiosInstance } from "lib";


export const deleteUserData = (data={}) => {
  return axiosInstance
    .post(API.DELETE_USER , data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
//      throw err;
    });
};

export const getUserDetailsData = (data={}) => {
  return axiosInstance
    .post(API.GET_SINGLE_USER , data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
//      throw err;
    });
};
export const changeUserStatusData = (data={}) => {
  return axiosInstance
    .post(API.USER_STATUS , data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
//      throw err;
    });
};

export const getCompanyDetailsApi = (data={}) => {
  return axiosInstance
    .post(API.GET_COMPANY_DETAILS , data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
//      throw err;
    });
};

export const updateCompanyApi = (data={}) => {
  return axiosInstance
    .post(API.UPDATE_COMPANY_END_POINT , data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
//      throw err;
    });
};


export const createGpsIntrigationApi = (data={}) => {
  return axiosInstance
    .post(API.GPS_INTRIGATION , data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
//      throw err;
    });
};

export const updateCompanySetting = (data={}) => {
  return axiosInstance
    .post(API.UPDATE_COMPANY_SETTING , data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
//      throw err;
    });
};


